import { render } from "./CaptchaBox.vue?vue&type=template&id=d3be54b8&ts=true"
import script from "./CaptchaBox.vue?vue&type=script&lang=ts"
export * from "./CaptchaBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__